export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  color: string;
}

export const categories: Category[] = [
  {
    slug: 'programming',
    name: '编程开发',
    description: '前端、后端、移动端等编程技术交流与实战经验分享',
    icon: 'ri-code-s-slash-line',
    color: 'accent',
  },
  {
    slug: 'network',
    name: '网络技术',
    description: '网络架构、协议分析、安全防护、服务器运维等深度讨论',
    icon: 'ri-global-line',
    color: 'primary',
  },
  {
    slug: 'tools',
    name: '工具软件',
    description: '开发工具、效率软件、系统工具的使用技巧与推荐',
    icon: 'ri-tools-line',
    color: 'secondary',
  },
  {
    slug: 'ai-data',
    name: 'AI与数据',
    description: '人工智能、机器学习、数据分析与大数据技术前沿探讨',
    icon: 'ri-robot-2-line',
    color: 'accent',
  },
  {
    slug: 'os-devops',
    name: '系统与运维',
    description: 'Linux系统管理、DevOps实践、云计算与容器技术',
    icon: 'ri-server-line',
    color: 'primary',
  },
  {
    slug: 'hardware',
    name: '硬件数码',
    description: '硬件评测、DIY装机、数码产品、嵌入式开发交流',
    icon: 'ri-cpu-line',
    color: 'secondary',
  },
];